import { useContext } from 'react';

import { HoneycombColorSchemeContext } from '../context/honeycomb-color-scheme.context.js';

export const useHoneycombColorScheme = () =>
  useContext(HoneycombColorSchemeContext);
